export default "__VITE_ASSET__F76zyesv__"